import {
    activeLinks,
    registerAlert,
    registerDatePiker,
    registerModal,
    registerSelect,
    registerServicesTabs,
    registerServiceTabs,
    registerSwiper,
    registerTooltip
} from "./ui";
import 'simplebar';
import {Ajax} from "./Ajax";
import {on} from "./helpers";
import axios, {Method} from "axios";
import {registerEditor} from "./editor";
import SimpleBar from "simplebar";
import {Notify} from "./notify";
import {Modal} from "./modal";

const init = (document: Document) => {
    registerServicesTabs(document);
    registerServiceTabs(document);
    registerModal(document);
    registerDatePiker(document);
    registerTooltip(document);
    registerSelect(document);
    registerEditor(document);
    registerSwiper(document);
    registerAjaxBlock(document);
    loadSvg(document);
    activeLinks(document);

    window.document.querySelectorAll('.ya-share2').forEach(element => {
        // @ts-ignore
        Ya.share2(element, {
            content: {
                url: window.location.href,
            }
        });
    });

    const simpleBar = new SimpleBar(document.querySelector('[data-simplebar]'));
    simpleBar.getScrollElement().addEventListener('scroll', event => {
        const scrollPosition = simpleBar.getScrollElement().scrollTop;
        const menu = document.querySelector('.main-menu');
        const scrollTopButton = document.querySelector('.util-menu .scroll-top');
        if (scrollPosition > 0) {
            menu.classList.add('scroll');
            scrollTopButton.classList.add('visible');
        } else {
            menu.classList.remove('scroll');
            scrollTopButton.classList.remove('visible');
        }
    });
    document.addEventListener(
        'scrollTop',
        () => simpleBar.getScrollElement().scroll({top: 0, behavior: 'smooth'}),
        false,
    );
}

registerAlert();

document.querySelector('.scroll-top').addEventListener('click', () => {
    document.dispatchEvent(new Event('scrollTop'));
});

document.body.classList.remove('rendering');


on('click', 'a[data-ajax]', (event, element: HTMLLinkElement) => {
    if (element.href == window.location.href) {
        event.preventDefault();
        return false;
    }
    if (element.nodeName.toLocaleLowerCase() == 'form') {
        return;
    }
    event.preventDefault();
    ajax.go(element.href, element.dataset.ajax).then(doc => {
        if (element.dataset.openOnTop !== undefined) {
            document.dispatchEvent(new Event('scrollTop'));
        }
    });
});

on('submit', '[data-ajax="main"]', (event, element: HTMLFormElement) => {
    event.preventDefault();
    const formData = new FormData(element);
    ajax.go(element.action, element.dataset.ajax, element.method as Method, formData);
});

on('submit', '[data-ajax="cart"]', (event, element: HTMLFormElement) => {
    event.preventDefault();
    const formData = new FormData(element);
    ajax.silent(element.action, element.dataset.ajax, element.method as Method, formData, response => {
        const data = response.querySelector('[data-ajax-container=main]') as HTMLElement;
        new Notify(data);
        return false;
    });
});

on('submit', '[data-ajax="modal"]', (event, element: HTMLFormElement) => {
    event.preventDefault();
    const formData = new FormData(element);
    ajax.silent(element.action, element.dataset.ajax, element.method as Method, formData, response => {
        const data = response.querySelector('[data-ajax-container=main]') as HTMLElement;
        const modal = new Modal(data);
        modal.open();
        return false;
    });
});

function registerAjaxBlock(document: Document) {
    document.querySelectorAll('[data-onload]').forEach((element: HTMLElement) => {
        axios({
            url: element.dataset.onload,
            method: 'get',
        }).then(response => {
            Modal.closeAll();
            element.innerHTML = response.data;
        }).catch(error => {
            console.log(error);
        });
    });
}

function loadSvg(document: Document) {
    const img: HTMLImageElement | null = document.querySelector('img[src$=".svg"]');
    if (img === null) {
        return;
    }
    axios({
        url: img.src,
        method: 'get',
    }).then(response => {
        img.outerHTML = response.data;
    }).catch(error => {
        console.log(error);
    });
}

window.addEventListener('popstate', event => {
    event.preventDefault();
    ajax.go(window.location.href, 'main');
    return false;
});

const ajax = new Ajax(element => {
    init(element);
});

init(document);
